import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {
    getInterpsShortName,
    transformInterpToCSSClass,
} from '../../../common/utils/studentsListHelpers';
import { INTERPRETATIONS } from '../../../constants/interpretations';
import Button from '../../button/Button';

const MeasureScore = ({ score, interpretation, onClick, path, additionalCssClasses }) => {
    if (score === undefined) return <div />;

    const interpsShortName = getInterpsShortName(interpretation);
    const interpsCssClass = transformInterpToCSSClass(
        interpsShortName || INTERPRETATIONS.NO_INTERPRETATION,
    );

    const cssClasses = classNames(
        'dashboard-assess-icon-item', // unique selector for selenium tests
        // HACK: empty string is added for correct prefixing
        // issue https://github.com/vezetvsem/react-classname-prefix-loader/issues/3
        'dashboard-measure-score',
        'dashboard-' + interpsCssClass,
        'dashboard-' + additionalCssClasses,
    );

    const scoreInfo = (
        <>
            <div className='dashboard-score'>{score}</div>
            {interpretation && <div className='dashboard-interpretation'>{interpsShortName}</div>}
        </>
    );

    if (path !== undefined) {
        return (
            <a className={cssClasses} href={path} onClick={onClick}>
                {scoreInfo}
            </a>
        );
    }
    if (typeof onClick === 'function') {
        return (
            <Button cssClasses={cssClasses} onClick={onClick}>
                {scoreInfo}
            </Button>
        );
    }

    return <div className={cssClasses}>{scoreInfo}</div>;
};

MeasureScore.propTypes = {
    score: PropTypes.number,
    interpretation: PropTypes.string,
    path: PropTypes.string,
    onClick: PropTypes.func,
    additionalCssClasses: PropTypes.string,
};

MeasureScore.defaultProps = {
    score: undefined,
    interpretation: 'dashboard-',
    path: undefined,
    onClick: null,
    additionalCssClasses: 'dashboard-',
};

export default MeasureScore;
